import { Injectable } from '@angular/core';
import { WebserviceExceptionComponent } from './webservice-exception.component';

export interface ProblemJson {
	type: string;
	status: number;
	details: string[];
	message?: string;
	stacktrace?: string[];
}

/**
 * Leitet allgemeine Fehler an die zuletzt registrierte `<bas-webservice-exception>` weiter. Die Ausgaben bilden einen Stapel,
 * damit z. B. ein Dialog mit eigener Ausgabe die der Seite nur verdeckt und sie nach dem Schließen wieder gilt.
 */
@Injectable({ providedIn: 'root' })
export class WebserviceExceptionService {
	private outputComponents: WebserviceExceptionComponent[] = [];

	constructor() {
	}

	public handleError(error: ProblemJson): void {
		this.topOutput()?.displayError(error);
	}

	public clearErrors(): void {
		this.topOutput()?.clearErrors();
	}

	/** Legt die Ausgabe oben auf den Stapel. */
	public registerOutput(outputComponent: WebserviceExceptionComponent): void {
		this.outputComponents.push(outputComponent);
	}

	/** Entfernt genau diese Ausgabe, auch wenn sie nicht oben liegt. */
	public removeOutput(outputComponent: WebserviceExceptionComponent): void {
		this.outputComponents = this.outputComponents.filter(component => component !== outputComponent);
	}

	private topOutput(): WebserviceExceptionComponent | undefined {
		return this.outputComponents.at(-1);
	}
}